import { render, staticRenderFns } from "./delivery-emergencyContactInfo.vue?vue&type=template&id=33ef5cec&scoped=true&"
import script from "./delivery-emergencyContactInfo.vue?vue&type=script&lang=js&"
export * from "./delivery-emergencyContactInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ef5cec",
  null
  
)

export default component.exports